import PersonalizeEvents from "aws-sdk/clients/personalizeevents";
import PersonalizeRuntime from "aws-sdk/clients/personalizeruntime";

const config = {
  region: process.env.AWS_REGION,
  credentials: {
    accessKeyId: process.env.AWS_ACCESS_KEY,
    secretAccessKey: process.env.AWS_SECRET_KEY,
  },
};

const personalizeEvents = new PersonalizeEvents(config);
export const personalizeClient = new PersonalizeRuntime(config);
export default personalizeEvents;
